var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.468 6 6 10.468 6 16C6 21.532 10.468 26 16 26C21.532 26 26 21.532 26 16C26 10.468 21.532 6 16 6ZM11.7873 16.8936C10.8937 16.8936 10.2128 16.1703 10.2128 15.3191C10.2128 14.4255 10.9361 13.7446 11.7873 13.7446C12.6809 13.7446 13.3618 14.468 13.3618 15.3191C13.3618 16.1703 12.6383 16.8936 11.7873 16.8936ZM14.3404 11.234C14.3404 10.3404 15.0638 9.65948 15.9149 9.65948C16.8085 9.65948 17.4894 10.3828 17.4894 11.234C17.4894 12.085 16.7661 12.8085 15.9149 12.8085C15.0638 12.8511 14.3404 12.1276 14.3404 11.234ZM17.4893 18.0425C16.5957 18.0425 15.9148 17.3192 15.9148 16.468C15.9148 15.5744 16.6381 14.8935 17.4893 14.8935C18.3829 14.8935 19.0638 15.6169 19.0638 16.468C19.1064 17.3192 18.3829 18.0425 17.4893 18.0425Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowling);
export default __webpack_public_path__ + "static/media/Bowling.1031f0a8ba051edc268cb7f86bc3737d.svg";
export { ForwardRef as ReactComponent };